export const isLogoutPage = () => window.location.pathname.includes("logout");
